import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/shared/services/user.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Person } from 'src/app/shared/models/person.model';
import { BankAccount } from 'src/app/shared/models/bank-account.model';
import { PasswordChangeForm } from 'src/app/shared/models/auth/password-change-form.model';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { Employee } from 'src/app/shared/models/employee.model';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { pipe, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html'
})
export class ProfileComponent implements OnInit {

  profileForm: FormGroup;
  authEmployeeId: number;
  authEmployeeDetails$: Observable<Employee>;
  constructor(
    private userService: UserService,
    private employeeService: EmployeeService,
    private fb: FormBuilder,
    private authService: AuthService,
    private toastrService: ToastrService,

  ) { }

  ngOnInit() {
    this.createFormGroup();
    this.authEmployeeId = this.userService.getCurrentUserId();
    this.authEmployeeDetails$ = this.employeeService.fetchEmployee(this.authEmployeeId).pipe(
      tap(employee => {
        this.profileForm.patchValue({
          user: {
            firstName: employee.person.firstName,
            lastName: employee.person.lastName,
            address1: employee.person.addresses[0].address1,
            address2: employee.person.addresses[0].address2,
            phoneNumber: employee.person.phoneNumber,
            accountNumber: employee.person.bankAccounts[0].number,
            accountName: employee.person.bankAccounts[0].name,
          },
          email: employee.user.email
        })
      }
      ))
  }


  createFormGroup() {
    this.profileForm = this.fb.group({
      user: this.fb.group({
        firstName: [null, Validators.required],
        lastName: [null, Validators.required],
        address1: [],
        address2: [],
        phoneNumber: [],
        accountNumber: [],
        accountName: []
      }),
      email: [null, [Validators.required, Validators.email]],
      password: this.fb.group({
        oldPassword: [null, Validators.required],
        newPassword: [null, Validators.required],
        newPasswordConfirmation: [null, Validators.required]
      }, { validators: this.checkPassword })
    });
  }


  saveUserDetails() {
    const user = this.profileForm.value.user;
    const person = {
      firstName: user.firstName,
      lastName: user.lastName,
      phoneNumber: user.phoneNumber,
      addresses: [
        {
          address1: user.address1,
          address2: user.address2
        }
      ],
      bankAccounts: [
        {
          number: user.accountNumber,
          name: user.accountName
        }
      ]
    };
    const employee = Employee.adapt({ person });

    this.userService.updateProfile(employee).subscribe(_ => {
      this.toastrService.success('Pomyślnie zaktualizowano.');
    })
  }

  changeEmail() {
    this.authService.changeEmail(this.profileForm.get('email').value).subscribe(
      _ => this.toastrService.success('Poprawnie zmieniono adres email'),
      _ => this.toastrService.error('Nie udało się zmienić adresu email')
    )
  }

  changePassword() {
    const passwordChangeForm = PasswordChangeForm.adapt(this.profileForm.value.password);
    this.authService.changePassword(passwordChangeForm).subscribe(response => {
      this.toastrService.success('Poprawnie zmieniono hasło.');
    },
      _ => this.toastrService.error('Nie udało się zmienić hasła')
    );
  }


  checkPassword(passwordGroup: FormGroup) {
    let newPassword = passwordGroup.get('newPassword').value;
    let newPasswordConfirmation = passwordGroup.get('newPasswordConfirmation').value;
    if (newPassword === newPasswordConfirmation) {
      return null;
    } else {
      passwordGroup.get('newPasswordConfirmation').setErrors({ passwordConfirmationInvalid: true })
      return { passwordConfirmationInvalid: true }
    }
  }




}
